import React, { useState } from 'react'

interface ILocationVaultHeader {
    onSearch: (value: any) => void;
    onCreate: (type: any) => void;
    query: any
    vaultType: any
}

const LocationVaultHeader = (props: ILocationVaultHeader) => {

    const [isShowOption, setIsShowOption] = useState(false)

    return (
        <div className="lv-topbar">
            <h1 className="lv-topbar__title">{props?.vaultType == 'myvault' ? "My Vault" : 'Location Vault'}</h1>
            <div className="lv-topbar__right">
                <div className="lv-search">
                    <input
                        className="lv-search__input"
                        placeholder="Tell us what you are looking for...."
                        value={props?.query || ''}
                        onChange={(evt) => props?.onSearch?.(evt.target.value)}
                    />
                    <div className="lv-search__icon">
                        <img src='../assets/images/search-icon.svg' width={18} height={18} alt='search' />
                    </div>
                </div>
                <div className="lv-card__menu-wrap">
                    <button className="lv-btn-create" onClick={() => setIsShowOption((prevState) => !prevState)}>
                        Create New
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                            <polyline points="6 9 12 15 18 9" />
                        </svg>
                    </button>
                    {isShowOption && (
                        <div className="create-info-menu" onClick={e => e.stopPropagation()}>
                            <button
                                type='button'
                                onClick={() => {
                                    setIsShowOption(false)
                                    props?.onCreate('location')
                                }}
                                className="create-info-menu__item">
                                <img src='/assets/images/marker.svg' />
                                Location
                            </button>
                            <button
                                type='button'
                                onClick={() => {
                                    setIsShowOption(false)
                                    props?.onCreate('collection')
                                }}
                                className="create-info-menu__item">
                                <img src='/assets/images/collection-active.svg' />
                                Collection
                            </button>
                            <button
                                onClick={() => {
                                    setIsShowOption(false)
                                    props?.onCreate('script')
                                }}
                                type='button'
                                className="create-info-menu__item" >
                                <img src='/assets/images/perscript-active.svg' />
                                Script
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default LocationVaultHeader